
import { useState, useEffect } from 'react';
import { AppNotification, UserProfile } from '../types';
import { NotificationService } from '../services/NotificationService';
import { User } from 'firebase/auth';

interface NotificationManagementProps {
    user: User | null;
    userProfile: UserProfile | null;
}

export const useNotificationManagement = ({ user, userProfile }: NotificationManagementProps) => {
    const [notifications, setNotifications] = useState<AppNotification[]>([]);

    useEffect(() => {
        if (!user || !userProfile?.orgId) {
            setNotifications([]);
            return;
        }
        return NotificationService.listenToNotifications(user.uid, userProfile.orgId, setNotifications);
    }, [user, userProfile?.orgId]);

    const markNotificationAsRead = async (id: string) => {
        await NotificationService.markAsRead(id);
    };

    const markAllNotificationsAsRead = async () => {
        if (!user || !userProfile?.orgId) return;
        await NotificationService.markAllAsRead(notifications);
    };

    const clearAllNotifications = async () => {
        if (!user || !userProfile?.orgId) return;
        await NotificationService.clearAll(notifications);
    };

    return {
        notifications,
        markNotificationAsRead,
        markAllNotificationsAsRead,
        clearAllNotifications
    };
};
